import { render, staticRenderFns } from "./sideBarItem.vue?vue&type=template&id=696af9b0&"
import script from "./sideBarItem.vue?vue&type=script&lang=js&"
export * from "./sideBarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports